/* eslint-disable no-new */
import Vue from 'vue'
// 格式化金额
Vue.filter('ckyfilterNum', function (value) {
  const nums = parseFloat(value || 0).toFixed(2)
  const tostringNum = nums.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  return '￥ ' + tostringNum
})

// 格式化商品名称
Vue.prototype._goodsFormat = function(goodsArr) {
   goodsArr.map((item, index) => {
    let str = ''
    if (!item) {
      return
    }
    item.attributes.map((its, index) => {
      str += its.productAttribute + ' ' + its.productAttributeValue + ' '
    })
    if (str) {
      item.spuName = item.spuName + ' ' + '[' + str + ']'
    }
  })
}
// 返回上一级并刷新页面
Vue.prototype._gobackRefresh = function (_this, path,topath,code) {
  if (path) {
    _this.$store.dispatch('delVisitedViews', {path:path})
  }
  _this.$store.commit('DEL_VISITED_VIEWS', {path:topath})
  _this.$nextTick(() => {
    _this.$bus.$emit('refresh-grid',null,code)
  })
  if (topath) {
    _this.$router.push({'path':topath})
  } else {
    _this.$router.go(-1)
  }

}



// WEBPACK FOOTER //
// ./src/_app/wwka/src/index.js